/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React, { useEffect, useState } from "react";
import { discovery } from "dc-core";
import { bottomBannerEvents } from "utils/BottomBannerDropinUtils";

const BottomBannerDropinWrapper = ({ dropinId, registerEventHandler, getInitialContext }) => {
  const [BottomBannerCmp, setBottomBannerCmp] = useState(null);
  const [initialContext, setInitialContext] = useState(null);

  const defaultConfig = {
    hideAndOpenOnLHP: true,
    hideAndOpenOnRHP: true,
    hideAndOpenOnRHPResize: true,
    hideAndOpenOnZoom: true,
    hideAndOpenOnScroll: true,
    hideOnSelection: true
  };

  const resetConfig = {
    hideAndOpenOnLHP: false,
    hideAndOpenOnRHP: false,
    hideAndOpenOnRHPResize: false,
    hideAndOpenOnZoom: false,
    hideAndOpenOnScroll: false,
    hideOnSelection: false
  };

  const subscribe = (callback, config = {}) => {
    if (callback && typeof callback === "function") {
      bottomBannerEvents.on("contextChange", callback);

      registerEventHandler({ ...defaultConfig, ...config });
    }
    return () => {
      bottomBannerEvents.unregister("contextChange", callback);

      registerEventHandler(resetConfig);
    };
  };

  useEffect(() => {
    if (!BottomBannerCmp) {
      (async () => {
        try {
          const Cmp = await discovery.loadDropinClass(dropinId);
          setBottomBannerCmp(() => Cmp);
        } catch (err) {}
      })();
    }

    if (!initialContext) {
      (async () => {
        const context = await getInitialContext();
        setInitialContext(() => context);
      })();
    }
  }, []);

  return BottomBannerCmp && initialContext ? (
    <BottomBannerCmp initialContext={initialContext} subscribe={subscribe} />
  ) : null;
};

export default BottomBannerDropinWrapper;
